module.exports = __webpack_public_path__ + "img/Icon ionic-ios-search.ae49a4e3.svg";